module.exports = __webpack_public_path__ + "static/choldrith-a7aaaeb87f553bf25479fe7fda1d53e5.jpeg";